import createCache from "@emotion/cache";
import { CacheProvider, ThemeProvider } from "@emotion/react";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  createTheme,
} from "@mui/material";
import { Box } from "@mui/system";
import DOMPurify from "dompurify";
import { convertFromHTML, convertToHTML } from "draft-convert";
import { ContentState, EditorState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { Formik } from "formik";
import htmlToDraft from "html-to-draftjs";
import React, { useEffect, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import * as Yup from "yup";
import DatePickerComponents from "../../components/datePicker/DatePickerComponents";
import MultiSelect from "../../components/dropdown/MultiSelect";
import FileUploader from "../../components/dropzone/FileUploader";
import ModalNoticeInfo from "../../components/modals/ModalNoticeInfo";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import LoadDocumentComponent from "../../components/thumbnail/LoadDocumentComponent";
import { SUPPLIERIDS, SUPPLIER_ID, TABLE_FILTER } from "../../config/cacheKey";
import { GetStatusResponse } from "../../models/basicInformation.model";
import { DocumentUrl } from "../../models/cartable.model";
import { ApiResultModel } from "../../models/common.model";
import {
  AddAttachmentRequest,
  DeleteAttachmentRequest,
  Files,
  NoticeItemDetail,
  NoticeItemRequest,
  NoticeItemResponse,
  ShowItemRequest,
} from "../../models/supplierNotice.model";
import { GetSuppliers } from "../../services/basicInformation.service";
import {
  AddAttachmentNotice,
  DeleteAttachmentNotice,
  InsertNotice,
  ShowItemNotice,
  UpdateNotice,
} from "../../services/supplierNotice.service";
import { convertToLocalDateTime } from "../../utility/dateUtility";

export default function AddNotification() {
  const getDate = convertToLocalDateTime(Number(new Date()));
  const theme = createTheme({
    direction: "rtl", // Both here and <body dir="rtl">
  });
  // Create rtl cache
  const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [prefixer, rtlPlugin],
  });

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );
  // const history = useHistory();
  const [valueSupplierIds, setValueSupplierIds] = useState<number[]>([]);
  const [valueSupplier, setValueSupplier] = useState<any[]>([]);
  const [convertedContent, setConvertedContent] = useState<string>();
  const [convertHtmlToText, setConvertHtmlToText] = useState<string>();
  const [imgUrl, setImgUrl] = useState<string[]>([]);
  const [tempImgUrl, setTempImgUrl] = useState<string[]>([]);
  const [expDate, setExpDate] = useState<boolean>(true);
  const [supplierIdsOptions, setSupplierIdsOptions] = React.useState<
    GetStatusResponse[]
  >([]);
  const [expirationDate, setExpirationDate] = React.useState<
    Date | undefined
  >();
  const [canSendSms, setCanSendSms] = React.useState<boolean | undefined>(
    false
  );
  const [showInLoginPage, setShowInLoginPage] = React.useState<
    boolean | undefined
  >(false);
  const [priority, setPriority] = React.useState<string | null | undefined>(
    "Information"
  );
  const [document, setDocument] = useState<DocumentUrl[]>([]);
  const [serviceObj, setServiceObj] = useState<DocumentUrl[]>([]);
  var temp = {} as NoticeItemDetail;
  const [noticeItem, setNoticeItem] = useState<NoticeItemDetail>(temp);
  const [defaultContent, setDefaultContent] = useState<any>();
  const [attachmentDocumentList, setAttachmentDocumentList] = useState<
    DocumentUrl[]
  >([]);
  const [getHtmlFromDB, setGetHtmlFromDB] = useState<any>();
  const [bodyValue, setBodyValue] = useState<string>();
  const [openVerifyModal, setOpenVerifyModal] = React.useState(false);
  const [sendConfirmation, setSendConfirmation] = React.useState(false);
  const [titleNotice, setTitleNotice] = React.useState<string>();
  const queryClient = useQueryClient();

  const yupVerificationMax = 50;
  const validationSchema = Yup.object().shape({
    title: Yup.string()
      .ensure()
      .required("این فیلد اجباری است")
      .max(
        yupVerificationMax,
        "مقدار این فیلد نمی تواند بیشتر از 50 کاراکتر باشد"
      ),
    // supplierIds: Yup.string()
    //     .ensure()
    //     .required("این فیلد اجباری است")
    //     .max(yupVerificationMax, "مقدار این فیلد نمی تواند بیشتر از 50 کاراکتر باشد"),
  });

  const titleHandleKeyDown = (event: any) => {
    var key = event.keyCode ? event.keyCode : event.which;
    if (
      event.target.value.length >= yupVerificationMax &&
      key != 8 &&
      key != 46
    ) {
      event.preventDefault();
    }
  };

  function changeValueSupplierIds(e: any, value: any) {
    // queryClient.setQueryData(SUPPLIER_ID, e);
    setValueSupplierIds(e);
    let partialStudentDetails = e?.map((item: any, index: number) =>
      e[index].id! ? e[index].id : e[index]
    );
    setValueSupplier(partialStudentDetails);
  }
  useQuery<GetStatusResponse[]>(SUPPLIERIDS, GetSuppliers, {
    onSuccess(data) {
      setSupplierIdsOptions(data);
    },
  });

  const handleEditorChange = (state: any) => {
    let blocks = convertToRaw(editorState.getCurrentContent());
    setBodyValue(blocks.blocks[0].text);
    if (
      tempImgUrl != null &&
      tempImgUrl != undefined &&
      imgUrl != null &&
      imgUrl != undefined &&
      tempImgUrl.length > imgUrl.length
    ) {
      setImgUrl(tempImgUrl);
      // setAttachmentDocumentList(tempImgUrl);
      addAttachment();
    } else {
      setEditorState(state);
    }
  };

  const history = useHistory<{ noticeKey: string }>();
  const noticeKey =
    history.location.state != null ? history.location.state.noticeKey : null;
  let getSupplierId: any[] | undefined;
  let getOptions: any[];

  const { mutateAsync: showItemNotice, isLoading, data } = useMutation(
    ShowItemNotice,
    {
      onSuccess: (data: ApiResultModel<NoticeItemDetail>) => {
        if (data !== null && data !== undefined) {
          setTitleNotice(data.data.title);
          setGetHtmlFromDB(data.data.body);
          setNoticeItem(data.data);
          setPriority(data.data.noticeType);
          setCanSendSms(data.data.canSendSms);
          setShowInLoginPage(data.data.showInLoginPage);
          setDefaultContent(data.data.body);
          setEditorState(
            EditorState.createWithContent(
              ContentState.createFromText(data.data.body)
            )
          );
          setValueSupplierIds(data.data.supplierIdList);
          // setSupplierIdsOptions(data.data.supplierIdList);
          setExpirationDate(new Date(data.data.expirationDate!));
          getSupplierId = queryClient.getQueryData(SUPPLIERIDS);
          data?.data?.supplierIdList?.map((item: any, index: number) => {
            getOptions = getSupplierId?.find((z: any) => z.id == item);
            setValueSupplier((oldArray) => [...oldArray, getOptions]);
            // setSupplierIdsOptions((oldArray) => [...oldArray, getOptions]);
          });
          getAttachment(data.data.attachments);
        }
      },
    }
  );
  const getAttachment = (file: DocumentUrl[]) => {
    file?.map((item: any, index: number) => {
      setImgUrl((oldArray) => [...oldArray, item.fileUrl]);
      setAttachmentDocumentList((oldArray) => [...oldArray, file[index]]);
      setTempImgUrl((oldArray) => [...oldArray, item.fileUrl]);
    });
    if (file == null) {
      setTempImgUrl((oldArray) => [...oldArray, "null"]);
    }
    getImageFileUpload(file);
  };
  React.useEffect(() => {
    if (noticeKey != null) {
      const noticeItem: ShowItemRequest = {
        noticeKey: noticeKey!,
        isVisited: undefined,
      };
      showItemNotice(noticeItem);
    }
    sanitizeEditorState(editorState);
    setServiceObj([]);
  }, []);
  useEffect(() => {
    if (
      tempImgUrl != undefined &&
      tempImgUrl != null &&
      tempImgUrl.length < imgUrl.length
    ) {
      setImgUrl(tempImgUrl);
    }
    sanitizeEditorState(editorState);
  }, [tempImgUrl]);

  let noticeItemRequest = {} as NoticeItemRequest;
  function submitForm() {
    let val = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    let currentContentAsHTML = convertToHTML(editorState.getCurrentContent());
    let blocks = convertToRaw(editorState.getCurrentContent());
    const value = blocks.blocks
      ?.map((block) => (!block.text.trim() && "\n") || block.text)
      .join("\n");
    setConvertHtmlToText(value);
    // setConvertedContent(currentContentAsHTML);
    setConvertedContent(val);
    noticeItemRequest = queryClient.getQueryData(TABLE_FILTER)!;
    noticeItemRequest.body = val!;
    noticeItemRequest.rawBody = value!;
    noticeKey
      ? UpdateNoticeMutation.mutateAsync(noticeItemRequest)
      : InsertNoticeMutation.mutateAsync(noticeItemRequest);
  }
  useEffect(() => {
    if (sendConfirmation == true) {
      let val = draftToHtml(convertToRaw(editorState.getCurrentContent()));
      let currentContentAsHTML = convertToHTML(editorState.getCurrentContent());
      let blocks = convertToRaw(editorState.getCurrentContent());
      const value = blocks.blocks
        ?.map((block) => (!block.text.trim() && "\n") || block.text)
        .join("\n");
      setConvertHtmlToText(value);
      // setConvertedContent(currentContentAsHTML);
      setConvertedContent(val);
      noticeItemRequest = queryClient.getQueryData(TABLE_FILTER)!;
      noticeItemRequest.body = val!;
      noticeItemRequest.rawBody = value!;
      noticeKey
        ? UpdateNoticeMutation.mutateAsync(noticeItemRequest)
        : InsertNoticeMutation.mutateAsync(noticeItemRequest);
      setSendConfirmation(false);
    }
  }, [sendConfirmation]);
  // useEffect(() => {
  //     setOpenVerifyModal(false);
  // }, [openVerifyModal])
  let blocks = convertToRaw(editorState.getCurrentContent());
  const test = blocks.blocks
    ?.map((block) => (!block.text.trim() && "\n") || block.text)
    .join("\n");

  const InsertNoticeMutation = useMutation(InsertNotice, {
    onSuccess: (result: ApiResultModel<NoticeItemResponse>) => {
      if (result.isSuccess == true) {
        toast.success("ثبت اطلاعات با موفقیت انجام شد.");
        history.push(`/setting/notificationList`);
        getImageFileUpload(result.data.attachments);
      }
    },
    onError: () => {},
  });
  const UpdateNoticeMutation = useMutation(UpdateNotice, {
    onSuccess: (result: ApiResultModel<boolean>) => {
      if (result.isSuccess == true) {
        toast.success("ثبت اطلاعات با موفقیت انجام شد.");
        history.push(`/setting/notificationList`);
      }
    },
    onError: () => {},
  });
  const AddAttachmentNoticeMutation = useMutation(AddAttachmentNotice, {
    onSuccess: (result: ApiResultModel<DocumentUrl[]>) => {
      if (result.isSuccess == true) {
        // getImageFileUpload(result.data);
        getAttachment(result.data);
      }
    },
    onError: () => {},
  });

  const sanitizeEditorState = (editorState: EditorState): EditorState => {
    let contentBlock;
    const htmlFromDB = getHtmlFromDB;
    const getCurrentEditorState = convertToHTML(
      editorState.getCurrentContent()
    );
    const removeSpaceEditorState = getCurrentEditorState
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&amp;/g, "&")
      .replace(/&quot;/g, "");
    const sanitizedHtml = DOMPurify.sanitize(removeSpaceEditorState);
    const sanitizedContentState = convertFromHTML(sanitizedHtml);
    htmlFromDB ? (contentBlock = htmlToDraft(htmlFromDB)) : htmlToDraft("");
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );
      setEditorState(EditorState.createWithContent(contentState));
    }
    return EditorState.createWithContent(sanitizedContentState);
  };
  const convertContentToHTML = () => {
    setOpenVerifyModal(true);
  };
  let type: any;
  const getImageFileUpload = (file: any) => {
    file?.map((item: any) => {
      var documentObj = {} as DocumentUrl;
      documentObj.fileUrl = item.fileUrl;
      documentObj.fileId = item.fileId;
      // setServiceObj((array) => [...array, documentObj]);
      // setAttachmentDocumentList([documentObj]);
    });
  };

  const getFileBase64 = async (file: any, callback: any) => {
    type = file.type.split("/");
    var documentObj = {} as DocumentUrl;
    documentObj.fileUrl = file;
    documentObj.fileType = type[1];
    documentObj.fileName = file.name;
    documentObj.fileData = file[0];
    setDocument((oldArray) => [...oldArray, documentObj]);
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => callback(reader.result);
    // TODO: catch an error
    reader.onerror = (error) => {};
    setTempImgUrl((oldArray) => [...oldArray, URL.createObjectURL(file)]);
  };
  const addAttachment = () => {
    if (noticeKey != undefined && noticeKey != null && document.length > 0) {
      const addAttachment = {} as AddAttachmentRequest;
      addAttachment.noticeKey = noticeKey;
      AddAttachmentNoticeMutation.mutateAsync(addAttachment);
    }
  };
  const imageUploadCallback = (file: any) =>
    new Promise((resolve, reject) => {
      getFileBase64(file, (data: any) => resolve({ data: { link: data } }));
    });

  const setChildValue = (childValues: any) => {
    setAttachmentDocumentList(childValues);
  };
  async function handleChoosedImage(image: any) {
    const maxSize = 1024 * 1000;
    // if (selectedValue === undefined) {
    //   toast.error("ابتدا عنوان مدرک را انتخاب نمایید.");
    //   return;
    // }
    if (noticeKey === undefined || noticeKey === null) {
      let fileUrlObj = {} as DocumentUrl;
      fileUrlObj.fileData = image.data;
      fileUrlObj.fileUrl = image.dataurl;
      fileUrlObj.fileName = image.data.name;

      let attachmentTemproryList = [...attachmentDocumentList, fileUrlObj];
      setAttachmentDocumentList(attachmentTemproryList);
      return;
    }
    if (image.data.size != null && image.data.size > maxSize) {
      toast.error("فایل سایز عکس مورد نظر بیشتر از اندازه مجاز است.");
      return;
    } else if (noticeKey != null && noticeKey != undefined) {
      const uploadAttachment = {} as AddAttachmentRequest;
      uploadAttachment.files = image.dataurl;
      uploadAttachment.noticeKey = noticeKey!;
      const addressFileObj = new Files();
      addressFileObj.file = image.data;
      uploadAttachment.files = [];
      uploadAttachment.files.push(addressFileObj);
      AddAttachmentNoticeMutation.mutate(uploadAttachment);
    }
  }
  async function handleOnFileChoosed(files: any) {
    if (noticeKey == null || noticeKey == undefined) {
      let fileUrlObj = {} as DocumentUrl;
      fileUrlObj.fileData = files[0];
      fileUrlObj.fileUrl = files[0].preview;
      fileUrlObj.fileName = files[0].name;
      let attachmentTemproryList = [...attachmentDocumentList, fileUrlObj];
      setAttachmentDocumentList(attachmentTemproryList);
    }
    files.map(async (item: any, idx: any) => {
      //   let maxSize = props.maxSize_KB!;
      let maxSize = 1024;
      if (maxSize === undefined) {
        maxSize = 1024 * 1000;
      }
      //convert KB to Byte--> size returns byte of size
      if (item.size != null && item.size > maxSize * 1000) {
        toast.error("سایز فایل مورد نظر بیشتر از اندازه مجاز است.");
        return;
      } else if (noticeKey != null && noticeKey != undefined) {
        const uploadAttachment = {} as AddAttachmentRequest;
        uploadAttachment.files = files[0].preview;
        uploadAttachment.noticeKey = noticeKey!;
        const addressFileObj = new Files();
        addressFileObj.file = files[0];
        uploadAttachment.files = [];
        uploadAttachment.files.push(addressFileObj);
        AddAttachmentNoticeMutation.mutate(uploadAttachment);
      }
    });
  }
  function deleteChip() {
    setValueSupplierIds([]);
    queryClient.setQueryData(SUPPLIER_ID, []);
    setValueSupplier([]);
    queryClient.setQueryData(SUPPLIER_ID, null);
  }

  const setChildValueSupplierIds = (childValues: any) => {
    //   let partialStudentDetails = e.map((item: any, index: number) =>
    //   e[index].id ? e[index].id : e[index]
    // );
    // setValueSupplier(partialStudentDetails);

    const selectedItem = valueSupplierIds.filter(
      (item: any) => item.id != childValues
    );
    const selectedItemValue = valueSupplier.filter(
      (item: any) => item.id != childValues
    );
    queryClient.setQueryData(SUPPLIER_ID, selectedItem);
    setValueSupplierIds(selectedItem);
    setValueSupplier(selectedItem);
  };
  const editorLabels = {
    // Generic
    "generic.add": "Add",
    "generic.cancel": "Cancel",

    // BlockType
    "components.controls.blocktype.h1": "عنوان 1",
    "components.controls.blocktype.h2": "عنوان 2",
    "components.controls.blocktype.h3": "عنوان 3",
    "components.controls.blocktype.h4": "عنوان 4",
    "components.controls.blocktype.h5": "عنوان 5",
    "components.controls.blocktype.h6": "عنوان 6",
    "components.controls.blocktype.blockquote": "نقل قول",
    "components.controls.blocktype.code": "کد",
    "components.controls.blocktype.normal": "عادی",
    "components.controls.blocktype.blocktype": "نوع بلوک",

    // Color Picker
    "components.controls.colorpicker.colorpicker": "انتخاب کننده رنگ",
    "components.controls.colorpicker.text": "متن",
    "components.controls.colorpicker.background": "پس زمینه",

    // Embedded
    // 'components.controls.embedded.embedded': 'Embedded',
    // 'components.controls.embedded.embeddedlink': 'Embedded Link',
    // 'components.controls.embedded.enterlink': 'Enter link',

    // FontFamily
    "components.controls.fontfamily.fontfamily": "فونت",

    // FontSize
    "components.controls.fontsize.fontsize": "سایز فونت",

    // History
    // 'components.controls.history.history': 'History',
    "components.controls.history.undo": "بازگردانی",
    "components.controls.history.redo": "باز انجام",

    // Image
    // 'components.controls.image.image': 'Image',
    // 'components.controls.image.fileUpload': 'File Upload',
    // 'components.controls.image.byURL': 'URL',
    // 'components.controls.image.dropFileText': 'Drop the file or click to upload',

    // Inline
    "components.controls.inline.bold": "توپر",
    "components.controls.inline.italic": "مورب",
    "components.controls.inline.underline": "خط کشیدن",
    "components.controls.inline.strikethrough": "خط خورده",
    "components.controls.inline.monospace": "تگ فاصله",
    "components.controls.inline.superscript": "بالانویس",
    "components.controls.inline.subscript": "زیرنویس",

    // List
    // 'components.controls.list.list': 'List',
    "components.controls.list.unordered": "نامرتب",
    "components.controls.list.ordered": "مرتب سازی",
    // 'components.controls.list.indent': 'Indent',
    // 'components.controls.list.outdent': 'Outdent',

    // TextAlign
    "components.controls.textalign.textalign": "چیدمان متن",
    "components.controls.textalign.left": "چپ",
    "components.controls.textalign.center": "مرکز",
    "components.controls.textalign.right": "راست",
    "components.controls.textalign.justify": "جاستیفای",
  };
  const changePriority = (e: any) => {
    setPriority(e.target.value);
  };
  const changeCanSendSms = (e: any) => {
    setCanSendSms(e.target.checked);
  };
  const changeShowSms = (e: any) => {
    setShowInLoginPage(e.target.checked);
  };
  const [value, setValue] = useState([]);
  if (!isLoading) {
    return (
      <Box>
        <Formik
          initialValues={noticeItem}
          validateOnMount={true}
          validationSchema={validationSchema}
          enableReinitialize={true}
          onSubmit={async (values: any) => {
            values.supplierIdList = valueSupplier;
            values.body = convertedContent;
            // values.body = DOMPurify.sanitize(html);
            values.rawBody = convertHtmlToText;
            values.expirationDate = expirationDate!
              ? convertToLocalDateTime(Number(expirationDate))
              : null;
            values.noticeType = priority;
            values.canSendSms = canSendSms;
            values.showInLoginPage = showInLoginPage;
            values.attachments = attachmentDocumentList;
            queryClient.setQueryData(TABLE_FILTER, values);
            setTitleNotice(values.title);
            // submitForm();
            // setOpenVerifyModal(true);
          }}
        >
          {({ handleSubmit, handleChange, values, errors, touched }) => (
            <form
              onSubmit={handleSubmit}
              onChange={handleChange}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSubmit();
                }
              }}
            >
              <Grid container xs={12} spacing={2}>
                <Grid
                  item
                  container
                  xs={12}
                  // spacing={{ xs: 4, md: 6 }}
                  // columns={{ xs: 4, sm: 8, md: 12 }}
                >
                  <Grid
                    item
                    xs={12}
                    md={6}
                    sm={12}
                    lg={4}
                    xl={4}
                    style={{ flexWrap: "nowrap" }}
                  >
                    <FormControl style={{ minWidth: "50%" }}>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        onChange={changePriority}
                        value={priority}
                        defaultValue={priority ? priority : "Information"}
                      >
                        <FormLabel
                          id="demo-row-radio-buttons-group-label"
                          className="colorDefaultFont textFont16"
                          style={{ alignSelf: "center" }}
                        >
                          اولویت :{" "}
                        </FormLabel>
                        <FormControlLabel
                          value="Information"
                          style={{ minWidth: "120px" }}
                          control={
                            <Radio
                              className={`${
                                priority == "Information"
                                  ? "SuccessDefaultFont"
                                  : priority == undefined
                                  ? "SuccessDefaultFont"
                                  : "disableColor"
                              }`}
                            />
                          }
                          className="colorDefaultFont textFont16"
                          label="اطلاع رسانی"
                        />
                        <FormControlLabel
                          value="Instant"
                          style={{ minWidth: "120px" }}
                          control={
                            <Radio
                              className={`${
                                priority == "Instant"
                                  ? "SuccessDefaultFont"
                                  : "disableColor"
                              }`}
                            />
                          }
                          className="colorDefaultFont textFont16"
                          label="آنی"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6} sm={12} lg={4} xl={4}>
                    <FormGroup onChange={changeCanSendSms}>
                      <FormControlLabel
                        checked={canSendSms}
                        control={
                          <Checkbox
                            className={`${
                              canSendSms ? "SuccessDefaultFont" : "disableColor"
                            }`}
                          />
                        }
                        className="colorDefaultFont textFont16"
                        label="ارسال پیامک"
                      />
                    </FormGroup>
                  </Grid>
                </Grid>
                <Grid
                  container
                  xs={12}
                  spacing={2}
                  style={{ marginTop: "2vh" }}
                  display={{ xs: "block", md: "flex" }}
                >
                  <Grid item>
                    <MaterialTextFieldComponent
                      // helperText={!touched.title ? errors.title : ""}
                      // // error={!touched.title && Boolean(errors.title)}
                      placeHolder={"عنوان"}
                      label={"عنوان"}
                      required={true}
                      value={values.title}
                      onChange={handleChange}
                      name="title"
                      id="title"
                      onFocus={true}
                      onKeyDown={titleHandleKeyDown}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  xs={12}
                  lg={8}
                  spacing={2}
                  style={{ marginTop: "2vh" }}
                  // flexDirection={{ xs: "row", md: "column" }}
                >
                  <Grid item xs={12} sm={6}>
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div dir="rtl">
                          <MultiSelect
                            items={supplierIdsOptions}
                            // getOptionDisabled={getOptionDisabled}
                            label="پذیرندگان دریافت کننده*"
                            placeholder="پذیرندگان دریافت کننده*"
                            selectAllLabel="انتخاب همه"
                            onChange={changeValueSupplierIds}
                            valueSupplier={valueSupplier}
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <DatePickerComponents
                      value={expirationDate}
                      label={"تاریخ انقضا "}
                      onChange={(newValue: any) => {
                        if (
                          convertToLocalDateTime(Number(newValue)) < getDate &&
                          newValue != undefined
                        ) {
                          toast.error("تاریخ انتخاب شده قابل قبول نمی باشد");
                          setExpDate(false);
                        } else {
                          setExpirationDate(newValue);
                          setExpDate(true);
                        }
                      }}
                      range={false}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  xs={12}
                  style={{ direction: "rtl", marginTop: "2vh" }}
                >
                  <Grid item>
                    <Editor
                      // handleKeyCommand={handleKeyCommand}
                      editorStyle={{ minHeight: "30vh" }}
                      onEditorStateChange={handleEditorChange}
                      editorState={editorState}
                      // editorState={sanitizeEditorState(editorState)}
                      wrapperClassName="wrapper-class"
                      editorClassName="editor-class"
                      toolbarClassName="toolbar-class"
                      placeholder="متن اطلاعیه*"
                      localization={{
                        locale: "en",
                        translations: editorLabels,
                      }}
                      toolbar={{
                        options: [
                          "blockType",
                          "fontSize",
                          "fontFamily",
                          "list",
                          "textAlign",
                          "history",
                          "inline",
                          "colorPicker",
                        ],
                        inputAccept:
                          "application/pdf,text/plain,application/vnd.openxmlformatsofficedocument.wordprocessingml.document,application/msword,application/vnd.ms-excel",
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid container xs={10} style={{ marginTop: "3vh" }}>
                  <Grid item xs={3}>
                    <FileUploader
                      handleImageSubmit={(e: any) => handleChoosedImage(e)}
                      handleOtherFiles={(e: any) => handleOnFileChoosed(e)}
                    />
                  </Grid>
                  {attachmentDocumentList?.map((item: any, key: number) => {
                    return (
                      <Grid item xs={3} style={{ maxHeight: "20vh" }}>
                        <LoadDocumentComponent
                          data={item}
                          setChildValue={setChildValue}
                          serviceName={DeleteAttachmentNotice}
                          multiItem={true}
                          attachments={attachmentDocumentList}
                          serviceRequestObj={
                            item.fileId != undefined
                              ? ({
                                  fileId: item.fileId,
                                } as DeleteAttachmentRequest)
                              : undefined
                          }
                        />
                      </Grid>
                    );
                  })}
                </Grid>
                <Grid container xs={12}>
                  <Grid item xs={10}>
                    {<hr />}
                  </Grid>
                </Grid>

                <Grid container xs={12} style={{ paddingTop: "2vh" }}>
                  <Grid
                    item
                    xs={10}
                    style={{ paddingLeft: "0", textAlign: "end" }}
                  >
                    <Button
                      type="submit"
                      disabled={
                        Object.keys(errors).length > 0 ||
                        valueSupplierIds?.length < 1 ||
                        bodyValue == "" ||
                        !expDate
                      }
                      className={`${
                        Object.keys(errors).length > 0 ||
                        valueSupplierIds?.length < 1 ||
                        bodyValue == "" ||
                        !expDate
                          ? "btnForm disabledBtn  "
                          : "btnForm SuccessDefault"
                      }`}
                      // className={"btnForm SuccessDefault"}
                      style={{ width: "120px" }}
                      onClick={convertContentToHTML}
                    >
                      ارسال اطلاعیه
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
        <ModalNoticeInfo
          openModel={openVerifyModal}
          setSendConfirmation={setSendConfirmation}
          setOpenVerifyModal={setOpenVerifyModal}
          setSendNotification={draftToHtml(
            convertToRaw(editorState.getCurrentContent())
          )}
          setSendBody={test}
          canSendSms={canSendSms}
          titleNotice={titleNotice}
        />
      </Box>
    );
  }
}
